// extracted by mini-css-extract-plugin
export default {"ExpandableArea":"_ExpandableArea--e3VFQ","Hidden":"_Hidden--KJ5PR","Row":"_Row--oYPd8","SigningDetailsArea":"_SigningDetailsArea--gvnNW","SectionHeader":"_SectionHeader--X_J2J"};